import { useActivityTemplateType } from "PFApp/activities/hooks";
import { AuditRoleProfileActionButtons } from "PFApp/audit_planner/parts/activity_buttons/audit_role_profile_action_buttons";
import { useMemo } from "react";

import {
  RoleProfileActionButtonsContent,
  RoleProfileActionButtonsContentProps
} from "./action_buttons/role_profile_action_buttons";
import {
  RoleProfileActionButtonsProvider,
  RoleProfileActionButtonsProviderProps
} from "./context/role_profile_action_buttons_context_provider";

export type RoleProfileActionButtonsWrapperProps = {
  isShortlistTabActive: boolean;
  isCompareView?: boolean;
  isOnMatchesTab?: boolean;
} & RoleProfileActionButtonsProviderProps &
  RoleProfileActionButtonsContentProps;

export const RoleProfileActionButtonsWrapper = ({
  role,
  customButton,
  areButtonsDisabled = false,
  small = false,
  className,
  isShortlistTabActive,
  isCompareView,
  isOnMatchesTab,
  ...props
}: RoleProfileActionButtonsWrapperProps) => {
  const { isAudit } = useActivityTemplateType(role);

  const buttonsContent = useMemo(() => {
    if (isAudit && !isCompareView) {
      return (
        <AuditRoleProfileActionButtons
          isShortlistTabActive={isShortlistTabActive}
          customButton={customButton}
        />
      );
    }

    return (
      <RoleProfileActionButtonsContent
        customButton={customButton}
        className={className}
        isOnMatchesTab={isOnMatchesTab}
      />
    );
  }, [isAudit, customButton, isCompareView, className, isShortlistTabActive, isOnMatchesTab]);

  return (
    <RoleProfileActionButtonsProvider
      {...props}
      role={role}
      areButtonsDisabled={areButtonsDisabled}
      small={small}
    >
      {buttonsContent}
    </RoleProfileActionButtonsProvider>
  );
};
